import React from 'react'
import NewNotification from '../../components/notifications/NewNotification'

const NotificationsPage = () => {
  return (
    <NewNotification />
  )
}

export default NotificationsPage